(function ($) {
    $(document).ready(function() {
        $('.vertical-tabs .tab-content:first').addClass('active');
        $('.vertical-tabs .tab').on('click', function() {
            $('.vertical-tabs .tab-content, .vertical-tabs .tabs-wrap .tab').removeClass('active');
            $(this).addClass("active");
            var tabId = $(this).data('tab');
            $('#' + tabId).addClass('active');
        });
    });
})(jQuery);